module.exports = __webpack_public_path__ + "img/collection-memoireRingsBudgetMedium@2x.ff3d454.webp";